import { KIT_DASHBOARD_ROUTE, KIT_ORDER_SETUP_RECIPIENT } from "@stadium/constants/kits";
import { isProduction } from "@constants/env-variables";
import { BYSTADIUM_DASHBOARD_HOSTNAME } from "@stadium/helpers/app-routes";
import { DEFAULT_WORKSPACE_ROUTE } from "@stadium/constants";

export const BYSTADIUM_DASHBOARD_HOSTNAME_WITH_WORKSPACE = `${BYSTADIUM_DASHBOARD_HOSTNAME}${DEFAULT_WORKSPACE_ROUTE}`;

export const externalRoutes = {
  home: () => `${BYSTADIUM_DASHBOARD_HOSTNAME_WITH_WORKSPACE}/dashboard`,
  chooseTemplates: () => `${BYSTADIUM_DASHBOARD_HOSTNAME_WITH_WORKSPACE}/shops/templates`,
  lockerDashboard: () => `${BYSTADIUM_DASHBOARD_HOSTNAME_WITH_WORKSPACE}/locker/collections/all`,
  lockerCollectionDetail: ({ catalogNumber }) =>
    `${BYSTADIUM_DASHBOARD_HOSTNAME_WITH_WORKSPACE}/locker/collection/${catalogNumber}`,
  dashboard: () => `${BYSTADIUM_DASHBOARD_HOSTNAME_WITH_WORKSPACE}/shops`,
  purchases: () => `${BYSTADIUM_DASHBOARD_HOSTNAME_WITH_WORKSPACE}/shops/my-orders/purchases`,
  storeDashboard: ({ number }) =>
    `${BYSTADIUM_DASHBOARD_HOSTNAME_WITH_WORKSPACE}/shops/${number}/branded-swag`,
  useTemplate: ({ number }) =>
    `${BYSTADIUM_DASHBOARD_HOSTNAME_WITH_WORKSPACE}/shops/create/edit-template?code=:code`.replace(
      ":code",
      number,
    ),
};

export const stadiumUrl = "https://www.bystadium.com/";

export const HELP_CENTER_SWAG_DECORATION_METHODS_ARTICLE =
  "https://help.bystadium.com/hc/en-us/articles/39320429147415-Swag-Decoration-Methods-at-Stadium";

export const kitDashboard = `${BYSTADIUM_DASHBOARD_HOSTNAME_WITH_WORKSPACE}${KIT_DASHBOARD_ROUTE}`;

const MARKETING_APP_PRODUCTION_URL = "https://www.bystadium.com/all-shop-templates";
const MARKETING_APP_STAGING_URL = "https://dev.bystadium.com/all-shop-templates";

export const SHOPS_DETAIL_MARKETING_PAGE = isProduction
  ? MARKETING_APP_PRODUCTION_URL
  : MARKETING_APP_STAGING_URL;

export const getKitOrderSetupRoute = (orderNumber) =>
  `${BYSTADIUM_DASHBOARD_HOSTNAME_WITH_WORKSPACE}${KIT_ORDER_SETUP_RECIPIENT.replace(
    ":number",
    orderNumber,
  )}`;
